import { required, schema } from '@angular/forms/signals';

import { OrganizationFormValue } from './organization-form.types';

/** Mirrors the pattern used by the dashboard's `CREATE_ORG_SCHEMA` (see `organization.schema-validators.ts`), scaled down to this widget's flat, native-select-based field shape. */
export const ORGANIZATION_FORM_SCHEMA = schema<OrganizationFormValue>(schemaPath => {
    required(schemaPath.name, { message: 'Organization name is required.' });
    required(schemaPath.primaryType, { message: 'Primary organization type is required.' });
    required(schemaPath.addressLine1, { message: 'Address is required.' });
    required(schemaPath.city, { message: 'City is required.' });
    required(schemaPath.state, { message: 'State is required.' });
    required(schemaPath.zipCode, { message: 'Zip code is required.' });
    required(schemaPath.country, { message: 'Country is required.' });
});
